import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eBusMonitoringActionTypeIds, IBusMonitoringActionTypes } from "../../action-types/bus/IBusMonitoringActionTypes";
import { IBusMonitoringPageStateModel } from "../../page-state-model/bus/IBusMonitoringPageState";

const initialState: IBusMonitoringPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	bus_monitorings: [],
	bus_monitoring_editing: undefined,
	bus_monitoring_selected_ids: [],
	is_show_delete_confirm: false,
	is_show_detail_modal: false
}

export const busMonitoringReducer = (state: IBusMonitoringPageStateModel = initialState, action: IBusMonitoringActionTypes): IBusMonitoringPageStateModel => {
	switch (action.type) {
		case eBusMonitoringActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eBusMonitoringActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_monitorings: action.payload
			}
		case eBusMonitoringActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_monitorings: []
			}
		case eBusMonitoringActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				bus_monitoring_editing: action.payload
			}
		case eBusMonitoringActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				bus_monitoring_editing: undefined
			}
		case eBusMonitoringActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				bus_monitoring_selected_ids: action.payload
			}
		case eBusMonitoringActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true
			}
		case eBusMonitoringActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false
			}
		case eBusMonitoringActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eBusMonitoringActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xoá dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false
			}
		case eBusMonitoringActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		case eBusMonitoringActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eBusMonitoringActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success("Thay đổi dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false
			}
		case eBusMonitoringActionTypeIds.SAVE_ERR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_detail_modal: false
			}
		default:
			return state;
	}
}
